import { initializeApp, getApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const requiredFirebaseEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID',
];

const missingFirebaseEnvVars = requiredFirebaseEnvVars.filter((key) => !process.env[key]);
if (missingFirebaseEnvVars.length > 0) {
  // Fail fast with a clear error instead of initializing with undefined config
  throw new Error(
    `Missing Firebase env vars: ${missingFirebaseEnvVars.join(', ')}. ` +
    'Create a .env file (not committed) with the REACT_APP_FIREBASE_* values.',
  );
}

// Initialize Firebase app first
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

// Initialize services after app initialization
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

// Configure Google provider for better mobile compatibility
googleProvider.setCustomParameters({
  prompt: 'select_account'
});
let analytics = null;

const initAnalytics = async () => {
  try {
    if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
      const analyticsSupported = await isSupported();
      if (analyticsSupported) {
        analytics = getAnalytics(app);
        console.log('Firebase Analytics initialized successfully');
      }
    }
  } catch (error) {
    console.error("Firebase Analytics initialization error:", error);
    analytics = null;
  }
};

// Initialize analytics
initAnalytics();

export { db, analytics, auth, storage, googleProvider }; 